import type { FaireProductEntity } from "../../entity_types/product";

export const p_89567e8gbr: FaireProductEntity = {
  token: "p_89567e8gbr",
  type: "product",
  name: "Best Hat Ever Graduation Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/88e6a2971bcc901f26a65a2ce52a8a557353b2e7b308f63da92e197e71ae6ec9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/296354c14800082e6a940b10f8fd2753eb0be733af3da5beda921f581c96b74c.jpeg",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:38.600Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
